import axios from "axios";

const endpoint = process.env.REACT_APP_API_URL;

export const FETCH_SUBSCRIPTION_BEGIN = "FETCH_SUBSCRIPTION_BEGIN";
export const FETCH_SUBSCRIPTION_SUCCESS = "FETCH_SUBSCRIPTION_SUCCESS";
export const FETCH_SUBSCRIPTION_FAILURE = "FETCH_SUBSCRIPTION_FAILURE";

export const fetchSubscriptionBegin = () => ({
  type: FETCH_SUBSCRIPTION_BEGIN,
});

export const fetchSubscriptionSuccess = (subscription) => ({
  type: FETCH_SUBSCRIPTION_SUCCESS,
  payload: subscription,
});

export const fetchSubscriptionFailure = (error) => ({
  type: FETCH_SUBSCRIPTION_FAILURE,
  payload: { error },
});

export const createSubscription = async (subscription) => {
  const created = await axios.post(`${endpoint}/subscriptions`, subscription);

  if (created.status !== 200) {
    throw new Error("Failed to create subscription");
  }
  return created;
};

export async function getSubscription(id) {
  return async (dispatch) => {
    dispatch(fetchSubscriptionBegin());
    try {
      const { data } = await axios.get(`${endpoint}/subscriptions/${id}`);
      dispatch(fetchSubscriptionSuccess(data));
    } catch (err) {
      dispatch(fetchSubscriptionFailure(err));
    }
  };
}


export const updateSubscription = async (id, update) => {
  const formData = new FormData();
  Object.keys(update).forEach(key => formData.append(key, update[key]));
  const updated = await axios.patch(`${endpoint}/subscriptions/${id}`, formData);

  if (updated.status !== 200) {
    throw new Error("Failed to update subscription");
  }
  return updated;
};
